import React from "react";
import { useCart } from "./CartContext";

const AddToCartComp = ({ setOpenDrawer, menuDataId }) => {
  const { newCart, updateQuantity } = useCart();

  const Data = newCart?.find((item) => {
    return (item?.product?.id || item?.id) === menuDataId;
  });

  function getQuantity(Data) {
    if (Data?.quantity !== undefined) {
      return Data.quantity;
    }
    if (Data?.product?.quantity !== undefined) {
      return Data.product.quantity;
    }
    return 0;
  }
  const quantity = getQuantity(Data);

  return (
    <div className="flex flex-col md:gap-3 gap-1">
      <div className="w-full md:p-3 sm:p-2 p-1 flex items-center justify-around border border-mediumGray rounded">
        <button
          onClick={() => {
            // window.location.reload();
            updateQuantity(menuDataId, "decrement");
          }}
        >
          -
        </button>
        <p>{quantity || 1}</p>
        <button
          onClick={() => {
            // window.location.reload();
            updateQuantity(menuDataId, "increment");
          }}
        >
          +
        </button>
      </div>
      {/* <div>
        <button
          onClick={() => setOpenDrawer(true)}
          className="w-full md:p-3 sm:p-2 p-1 styleButton"
        >
          View Cart
        </button>
      </div> */}
    </div>
  );
};

export default AddToCartComp;
